import { memo } from "../../../lib/memo";
var getConfig = memo(function (monthTitleLineHeight, monthTitlePaddingTop, monthTitlePaddingBottom, monthTitleMarginBottom, cellSize, wrapperHeight, monthMarginBottom, maxMonthsToAppendOnScroll) {
  var monthTitleHeight = parseInt(monthTitleLineHeight) + parseInt(monthTitlePaddingTop) + parseInt(monthTitlePaddingBottom);
  return {
    DAY_SIZE: parseInt(cellSize),
    MONTH_TITLE_HEIGHT: monthTitleHeight,
    MONTH_TITLE_OFFSET_HEIGHT: monthTitleHeight + parseInt(monthTitleMarginBottom) + 1,
    // + 1px separator line
    WRAPPER_HEIGHT: parseInt(wrapperHeight),
    MONTH_BOTTOM_MARGIN: parseInt(monthMarginBottom),
    MAX_MONTHS_TO_APPEND_ON_SCROLL: parseInt(maxMonthsToAppendOnScroll)
  };
});
export var themeConfig = function themeConfig(t) {
  return getConfig(t.calendarMonthTitleLineHeight, t.calendarMonthTitlePaddingTop, t.calendarMonthTitlePaddingBottom, t.calendarMonthTitleMarginBottom, t.calendarCellSize, t.calendarWrapperHeight, t.calendarMonthMarginBottom, t.calendarMaxMonthsToAppendOnScroll);
};